import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../../components/commonComponent/Form";
import { FIELDS, MODE } from "../../../../constants/SiteConstants";
import Loader from "../../../../components/commonComponent/Loader";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: FIELDS.NAME, name: "name", placeholder: "Enter Name" },
  { label: FIELDS.SLUG, name: "slug", placeholder: "Enter Slug" },
 
];

const EditBlogCategory = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadDoctorData = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/blogcategory/getblogcategoryById/${id}`
          );
          setInitialData(response.data.data);
        } catch (error) {}
      };
      loadDoctorData();
    }
  }, [id]);

  const handleSubmit = async (formData) => {
    try {
      await axios.put(`${API_URL}/blogcategory/updateblogcategoryById/${id}`, formData);
      toast.success("Data updated successfully", {
        autoClose: 1000,
      });
      navigate("/blog-category");
    } catch (error) {
      toast.error("Error updating data", {
        autoClose: 1000,
      });
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Update Blog Category
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/blog-category")}
        >
          &times;
        </button>
      </div>
      {initialData ? (
        <Form
          mode={MODE.UPDATE}
          onSubmit={handleSubmit}
          fields={fields}
          initialData={initialData}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default EditBlogCategory;
